import * as types from "../types";

const initialState = {
  loading: false,
  fuelSummary: null,
  requestDevice: null,
  error: null,
};

export default function fetchFuelSummaryReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_FUEL_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.FETCH_FUEL_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        fuelSummary: action.payload.fuelSummary,
      };

    case types.FETCH_FUEL_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        fuelSummary: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
